<template>
    <span class="custom-badge" :class="badgeColor" v-if="displayStatus">
        {{ displayStatus }}
    </span>
</template>

<script>
export default {
    name: 'StatusBadgeRenderer',
    data() {
        return {
            displayStatus: null,
            badgeColor: null
        };
    },
    beforeMount() {
        if (this.params) {
            this.updateDisplay(this.params);
        }
    },
    mounted() {
        if (this.status) {
            this.updateDisplay({ value: this.status });
        }
    },
    methods: {
        refresh(params) {
            this.updateDisplay(params);
        },
        updateDisplay(params) {
            this.displayStatus = params.status;
            this.badgeColor = params.badgeColor;
        }
    }
};
</script>

<style scoped>
.custom-badge {
    background-color: #c2907f;
    max-width: initial !important;
}
</style>
